









import { Component, Vue } from 'vue-property-decorator'
import { Member } from '@/types/Member.type'
import { namespace } from 'vuex-class'
import API from '@/services/API'
import FeedbackEventModal from '@/components/feedback/FeedbackEventModal.vue'
import FeedbackRelationshipModal from '@/components/feedback/FeedbackRelationshipModal.vue'
import { Feedback } from '@/types/Feedback.type'

const User = namespace('user')
@Component({
    components: { FeedbackRelationshipModal, FeedbackEventModal },
})
export default class FeedbackModal extends Vue {
    @User.State me!: Member
    feedback: Feedback | null = null
    paramFeedbackId: string | null = null
    paramFeedbackScore: string | null = null

    mounted() {
        const paramsUrl = new URLSearchParams(window.location.search)
        if (paramsUrl.has('__fb')) {
            this.paramFeedbackId = paramsUrl.get('__fb')
            this.paramFeedbackScore = paramsUrl.has('__fbs') ?  paramsUrl.get('__fbs') : '0' 
            const feedbackStep =  paramsUrl.has('__fbst') ?  paramsUrl.get('__fbst') : '1' 
            this.redirectFeedback(this.paramFeedbackId as string, feedbackStep as string)
        } else {
            this.getOneFeedback()
        }
    }

    redirectFeedback(feedbackId: string, feedbackStep: string) {
        API.getFeedback(feedbackId, feedbackStep)
            .then(feedback => {
                this.feedback = feedback
            })
            .catch(err => {
                this.feedback = null
                console.error(err)
            })
    }

    async getOneFeedback() {
        try {
            const feedbacks = await API.getPendingFeedbackIdList()

            if (!feedbacks.length) {
                return null
            }

            const ids = feedbacks.map(fb => fb.id)

            if (ids.length) {
                const feedback = await API.getFeedback(ids[0])
                this.feedback = feedback || null
            }
        } catch (e) {
            this.feedback = null
            console.error(e)
        }
    }
}
